import DateFnsUtils from "@date-io/date-fns";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Fade,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  makeStyles,
  MenuItem,
  Modal,
  Typography,
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssignees } from "../../../redux/actions/purchaseRequest.action";
import CustomSelectInput from "./../../inputs/CustomSelectInput";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function AssignFormModal({
  openModal,
  handleCloseModal,
  handleSubmit,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { assignees } = useSelector((state) => state.purchaseRequestReducer);
  const {
    result: { perid },
  } = useSelector((state) => state.loginReducer);

  const form = useRef();

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }

    if (openModal) {
      dispatch(getAssignees(perid));
    }

    return () => {};
  }, [openModal]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openModal}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableBackdropClick
    >
      <Fade in={openModal}>
        <div className={classes.paper}>
          {assignees.isLoading ? (
            <CircularProgress color="secondary" />
          ) : (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Formik
                ref={form}
                enableReinitialize
                initialValues={{
                  ASSIGN_PURCHASE_ID: "",
                }}
                validate={(values) => {
                  const errors = {};

                  if (!values.ASSIGN_PURCHASE_ID) {
                    errors.ASSIGN_PURCHASE_ID = "Required";
                  }

                  return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setTimeout(() => {
                    handleSubmit(values.ASSIGN_PURCHASE_ID);
                    resetForm({
                      values: "",
                    });
                    setSubmitting(false);
                    handleCloseModal();
                  }, 200);
                }}
              >
                {({ submitForm, errors, touched, isSubmitting }) => (
                  <Form noValidate>
                    <Typography gutterBottom variant="h5">
                      Select to Assignee
                    </Typography>
                    <Card className={classes.card}>
                      <CardContent>
                        <Grid container spacing={1}>
                          <FormControl className={classes.inputForm}>
                            <InputLabel
                              error={Boolean(
                                errors.ASSIGN_PURCHASE_ID &&
                                  touched.ASSIGN_PURCHASE_ID &&
                                  errors.ASSIGN_PURCHASE_ID
                              )}
                              id="select-assign-label"
                            >
                              Assign To
                            </InputLabel>
                            <Field
                              component={CustomSelectInput}
                              name="ASSIGN_PURCHASE_ID"
                              label="Select to Assineer"
                              labelId="select-assign-label"
                              fullWidth
                              error={Boolean(
                                errors.ASSIGN_PURCHASE_ID &&
                                  touched.ASSIGN_PURCHASE_ID &&
                                  errors.ASSIGN_PURCHASE_ID
                              )}
                              onChange={() => {}}
                            >
                              <MenuItem key={0} value="">
                                -
                              </MenuItem>
                              {assignees.data &&
                                assignees.data.map((item) => (
                                  <MenuItem key={item.PER_ID} value={item}>
                                    {item.PER_FULLNAME}
                                  </MenuItem>
                                ))}
                            </Field>
                          </FormControl>
                        </Grid>
                      </CardContent>

                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            m={1}
                            p={1}
                            flexWrap="wrap"
                          >
                            <Box p={1} display="flex" flexDirection="row">
                              <Box mr={5}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Submit
                                </Button>
                              </Box>
                              <Box mr={5}>
                                <Button
                                  onClick={handleCloseModal}
                                  color="default"
                                  raised
                                >
                                  Cancel
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  </Form>
                )}
              </Formik>
            </MuiPickersUtilsProvider>
          )}
        </div>
      </Fade>
    </Modal>
  );
}
